<div class="w-full text-center mb-4">
	<p class="text-2xl font-bold">Enter policy details</p>
	<p class="mt-2 text-base text-gray-600">
		Please complete the policy details below.
	</p>
</div>
<div class="mt-2">
	<div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-2">
		<div class="flex flex-col gap-2">
			<div>
				<app-container>
					<div class="flex flex-col gap-3">
						<app-order-number labelClass="flex-1"></app-order-number>
						<app-order-date labelClass="flex-1"></app-order-date>
						<app-effective-date labelClass="flex-1"></app-effective-date>
					</div>
				</app-container>
			</div>
			<div>
				<app-container>
					<div class="flex flex-col gap-3">
						<app-premium-amount labelPosition="left"></app-premium-amount>
						<app-counsel-credit labelPosition="left"></app-counsel-credit>
					</div>
				</app-container>
			</div>
		</div>
		<div class="flex flex-col gap-2 h-min lg:max-w-500">
			<div>
				<app-container>
					<app-title-insurance-documents
						type="default"
						[showCommercialForm]="true"
					></app-title-insurance-documents>
				</app-container>
			</div>
			<div>
				<app-container class="mb-5">
					<app-title-insurance-policies
						type="full"
					></app-title-insurance-policies>
				</app-container>
			</div>
		</div>
	</div>
</div>
